import { icon } from '../icons.js'
import { esc } from '../util.js'
import { putSeed, deleteSeed, listSeeds } from '../seeddb.js'

export function renderRegionSelect(root, regions) {
  listSeeds().then(localKeys => {
    const localSet = new Set(localKeys)
    render(root, regions, localSet)
  }).catch(() => {
    render(root, regions, new Set())
  })
}

function render(root, regions, localSet) {
  const cards = regions.map(r => {
    const isLocal = localSet.has(r.file)
    return `
    <a class="region-card" href="#/${esc(r.id)}/home">
      <span class="region-card-icon">${icon('map')}</span>
      <span class="region-card-body">
        <span class="region-card-title">${esc(r.label)}</span>
        <span class="region-card-base">${icon('home')} ${esc(r.homeBase)}</span>
      </span>
      ${isLocal ? `<span class="region-card-local" title="Lokale data actief">${icon('upload')}</span>` : ''}
      <span class="region-card-arrow">${icon('chevron-right')}</span>
    </a>`
  }).join('')

  root.innerHTML = `
    <div class="region-select">
      <div class="region-select-hero">
        <h1 class="region-select-title">Kies je reis</h1>
        <p class="region-select-sub">Waar ga je naartoe?</p>
      </div>
      <div class="region-list">${cards}</div>
      <div class="region-upload-section">
        <button class="btn secondary region-upload-btn" id="upload-seed-btn" type="button">
          ${icon('upload')} JSON uploaden
        </button>
        <p class="region-upload-hint">Upload een bijgewerkt databestand om de content lokaal te verversen.</p>
        ${localSet.size > 0 ? `
          <button class="btn secondary region-reset-btn" id="reset-seeds-btn" type="button">
            ${icon('rotate')} Lokale data wissen
          </button>
        ` : ''}
      </div>
      <input type="file" id="seed-file-input" accept=".json" hidden />
      <div id="upload-toast" class="upload-toast" hidden></div>
    </div>`

  const fileInput = root.querySelector('#seed-file-input')
  const uploadBtn = root.querySelector('#upload-seed-btn')
  const resetBtn = root.querySelector('#reset-seeds-btn')

  uploadBtn.addEventListener('click', () => fileInput.click())

  fileInput.addEventListener('change', async () => {
    const file = fileInput.files[0]
    if (!file) return
    try {
      const text = await file.text()
      const data = JSON.parse(text)

      if (!data.meta || !data.nodes) {
        showToast(root, 'Ongeldig bestand — meta of nodes ontbreekt.', true)
        return
      }

      const regionId = data.meta.region
      const matchByRegion = regions.find(r => r.id === regionId)
      const matchByFile = regions.find(r => r.file === file.name)
      const match = matchByFile || matchByRegion

      if (!match) {
        showToast(root, `Kan regio niet bepalen. Verwacht: ${regions.map(r => r.file).join(', ')}`, true)
        return
      }

      await putSeed(match.file, data)
      showToast(root, `${match.label} bijgewerkt — ${data.nodes.length} plekken geladen.`)
      setTimeout(() => render(root, regions, new Set([...localSet, match.file])), 1500)
    } catch (e) {
      showToast(root, `Fout: ${e.message}`, true)
    }
    fileInput.value = ''
  })

  if (resetBtn) {
    resetBtn.addEventListener('click', async () => {
      for (const key of localSet) {
        await deleteSeed(key)
      }
      showToast(root, 'Lokale data gewist — serverversie wordt weer gebruikt.')
      setTimeout(() => render(root, regions, new Set()), 1500)
    })
  }
}

function showToast(root, msg, isError = false) {
  const toast = root.querySelector('#upload-toast')
  if (!toast) return
  toast.textContent = msg
  toast.className = `upload-toast ${isError ? 'error' : 'success'}`
  toast.hidden = false
  setTimeout(() => { toast.hidden = true }, 4000)
}
